/**
 * Precioux Occasion Carousel - ORRA Style Moving Cards Section JS
 */
document.addEventListener('DOMContentLoaded', () => {
  initOccasionCarousels();
});

// Also initialize immediately if DOM ready
if (document.readyState === 'interactive' || document.readyState === 'complete') {
  initOccasionCarousels();
}

function initOccasionCarousels() {
  const roots = document.querySelectorAll('.precioux-occasions');
  roots.forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    const track = root.querySelector('[data-occasion-track]');
    const prevBtn = root.querySelector('[data-occasion-prev]');
    const nextBtn = root.querySelector('[data-occasion-next]');
    const dotsContainer = root.querySelector('[data-occasion-dots]');

    if (!track) return;
    const cards = [...track.children];
    if (!cards.length) return;

    const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
    let timer = null;
    let isHovered = false;

    // Calculate item step distance
    const getStepWidth = () => {
      const firstCard = cards[0];
      if (!firstCard) return 300;
      const gap = parseInt(window.getComputedStyle(track).gap) || 20;
      return firstCard.offsetWidth + gap;
    };

    // Calculate total pages
    const getPagesCount = () => {
      const step = getStepWidth();
      if (!step) return 1;
      const visibleCount = Math.max(1, Math.floor(track.clientWidth / step));
      return Math.max(1, Math.ceil(cards.length / visibleCount));
    };

    // Render pagination dots
    const renderDots = () => {
      if (!dotsContainer) return;
      dotsContainer.innerHTML = '';
      const totalPages = getPagesCount();

      if (totalPages <= 1) {
        dotsContainer.style.display = 'none';
        return;
      }
      dotsContainer.style.display = 'flex';

      for (let i = 0; i < totalPages; i++) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', `Go to slide ${i + 1}`);
        btn.addEventListener('click', () => {
          track.scrollTo({
            left: i * getStepWidth() * Math.max(1, Math.floor(track.clientWidth / getStepWidth())),
            behavior: 'smooth'
          });
        });
        dotsContainer.appendChild(btn);
      }
      updateDots();
    };

    // Update active dot based on scroll position
    const updateDots = () => {
      if (!dotsContainer) return;
      const step = getStepWidth();
      const visibleCount = Math.max(1, Math.floor(track.clientWidth / step));
      const pageIndex = Math.min(
        getPagesCount() - 1,
        Math.round(track.scrollLeft / (step * visibleCount))
      );

      [...dotsContainer.children].forEach((dot, index) => {
        dot.setAttribute('aria-current', String(index === pageIndex));
      });
    };

    // Move left or right
    const move = (direction) => {
      const maxScroll = track.scrollWidth - track.clientWidth - 4;
      const step = getStepWidth();

      if (direction > 0 && track.scrollLeft >= maxScroll) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (direction < 0 && track.scrollLeft <= 4) {
        track.scrollTo({ left: maxScroll, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: direction * step, behavior: 'smooth' });
      }
    };

    if (prevBtn) prevBtn.addEventListener('click', () => move(-1));
    if (nextBtn) nextBtn.addEventListener('click', () => move(1));

    // Drag to scroll handling
    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;

    track.addEventListener('mousedown', (e) => {
      isDragging = true;
      startX = e.pageX - track.offsetLeft;
      startScrollLeft = track.scrollLeft;
    });

    track.addEventListener('mouseleave', () => { isDragging = false; });
    track.addEventListener('mouseup', () => { isDragging = false; });

    track.addEventListener('mousemove', (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 1.5;
      track.scrollLeft = startScrollLeft - walk;
    });

    // Scroll listener for dot sync
    let scrollTimeout;
    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateDots, 60);
    }, { passive: true });

    // Auto carousel interval
    root.addEventListener('mouseenter', () => { isHovered = true; });
    root.addEventListener('mouseleave', () => { isHovered = false; });

    if (!reducedMotion) {
      timer = setInterval(() => {
        if (!isHovered && !document.hidden) {
          move(1);
        }
      }, 4200);
    }

    window.addEventListener('resize', () => {
      renderDots();
    }, { passive: true });

    renderDots();
  });
}
